import React from 'react'
import CIcon from '@coreui/icons-react'
import {
  cilBug,
  cilClipboard,
  cilCreditCard, cilChartLine, cilGroup, cilInfo, cilCog, cilList
} from '@coreui/icons'
import {CNavGroup, CNavItem, CNavTitle} from '@coreui/react'
import Roles from "./config/roles";

const _nav = [
  {
    component: CNavGroup,
    name: 'Stock',
    icon: <CIcon icon={cilClipboard} customClassName="nav-icon" />,
    roles: [Roles.ADMIN.role, Roles.REPONEDOR.role, Roles.ALMACEN.role, Roles.MARKETING.role ],
    items: [
      {
        component: CNavItem,
        name: 'Consulta',
        to: '/ubicaciones',
        roles: [Roles.ADMIN.role, Roles.REPONEDOR.role, Roles.ALMACEN.role, Roles.MARKETING.role]
      },
      {
        component: CNavItem,
        name: 'Inventario',
        to: '/inventario',
        roles: [Roles.ADMIN.role, Roles.REPONEDOR.role, Roles.ALMACEN.role]
      },
      {
        component: CNavItem,
        name: 'Inventarios',
        to: '/inventarios',
        roles: [Roles.ADMIN.role]
      },
      {
        component: CNavItem,
        name: 'Mis inventarios',
        to: '/mis-inventarios',
        roles: [Roles.ADMIN.role, Roles.REPONEDOR.role, Roles.ALMACEN.role]
      },
      {
        component: CNavItem,
        name: 'Traspasos',
        to: '/traspasos',
        roles: [Roles.ADMIN.role, Roles.REPONEDOR.role]
      },
      {
        component: CNavItem,
        name: 'Necesidad inmediata',
        to: '/reponer-inmediato',
        roles: [Roles.ADMIN.role, Roles.REPONEDOR.role]
      },
      {
        component: CNavItem,
        name: 'Reposición general',
        to: '/reponer-general',
        roles: [Roles.ADMIN.role, Roles.REPONEDOR.role]
      }
    ],
  },
  {
    component: CNavGroup,
    name: 'Rma',
    icon: <CIcon icon={cilBug} customClassName="nav-icon" />,
    roles: [Roles.ADMIN.role],
    items: [
      {
        component: CNavItem,
        name: 'RMA Tramitado',
        to: '/rma/2',
        roles: [Roles.ADMIN.role]
      },
      {
        component: CNavItem,
        name: 'RMA Pendiente',
        to: '/rma/4',
        roles: [Roles.ADMIN.role]
      }
    ],
  },
  {
    component: CNavGroup,
    name: 'Compras',
    icon: <CIcon icon={cilCreditCard} customClassName="nav-icon" />,
    roles: [Roles.ADMIN.role, Roles.REPONEDOR.role, Roles.ALMACEN.role],
    items: [
      {
        component: CNavItem,
        name: 'Recepcionar',
        to: '/compras/recepcionar',
        roles: [Roles.ADMIN.role, Roles.REPONEDOR.role, Roles.ALMACEN.role]
      },
      {
        component: CNavItem,
        name: 'Puntear pedidos',
        to: '/compras',
        roles: [Roles.ADMIN.role, Roles.REPONEDOR.role]
      }
    ],
  },
  {
    component: CNavGroup,
    name: 'Ventas',
    icon: <CIcon icon={cilChartLine} customClassName="nav-icon" />,
    roles: [Roles.ADMIN.role, Roles.REPONEDOR.role, Roles.ALMACEN.role],
    items: [
      {
        component: CNavItem,
        name: 'Pasar a preparación',
        to: '/estados',
        roles: [Roles.ADMIN.role, Roles.REPONEDOR.role, Roles.ALMACEN.role]
      },
      {
        component: CNavItem,
        name: 'Puntear pedidos',
        to: '/ventas',
        roles: [Roles.ADMIN.role, Roles.REPONEDOR.role, Roles.ALMACEN.role]
      },
      {
        component: CNavItem,
        name: 'Nave 2',
        to: '/pedidosn2',
        roles: [Roles.ADMIN.role, Roles.REPONEDOR.role, Roles.ALMACEN.role]
      },
      {
        component: CNavItem,
        name: 'Nave 2 - Agrupados',
        to: '/pedidosn2/grupos',
        roles: [Roles.ADMIN.role, Roles.REPONEDOR.role, Roles.ALMACEN.role]
      },
      {
        component: CNavItem,
        name: 'Etiquetas',
        to: '/panel',
        roles: [Roles.ADMIN.role, Roles.REPONEDOR.role, Roles.ALMACEN.role]
      }
    ],
  },
  {
    component: CNavGroup,
    name: 'Información pedidos',
    icon: <CIcon icon={cilInfo} customClassName="nav-icon" />,
    roles: [Roles.ADMIN.role, Roles.REPONEDOR.role, Roles.ALMACEN.role],
    items: [
      {
        component: CNavItem,
        name: 'Info pedidos',
        to: '/info',
        roles: [Roles.ADMIN.role, Roles.REPONEDOR.role, Roles.ALMACEN.role]
      },
      {
        component: CNavItem,
        name: 'Panel',
        to: '/estado-entregas-tv',
        roles: [Roles.ADMIN.role, Roles.REPONEDOR.role, Roles.ALMACEN.role]
      },
      {
        component: CNavItem,
        name: 'Envíos',
        to: '/envios',
        roles: [Roles.ADMIN.role]
      },
      {
        component: CNavItem,
        name: 'Recogidas',
        to: '/recogidas',
        roles: [Roles.ADMIN.role]
      }
    ],
  },
  {
    component: CNavGroup,
    name: 'Gestión',
    icon: <CIcon icon={cilCog} customClassName="nav-icon" />,
    roles: [Roles.ADMIN.role],
    items: [
      {
        component: CNavItem,
        name: 'Control pedidos compra',
        to: '/listado-estados-compras',
        roles: [Roles.ADMIN.role]
      },
      {
        component: CNavItem,
        name: 'Control pedidos venta',
        to: '/listado-estados',
        roles: [Roles.ADMIN.role]
      },
      {
        component: CNavItem,
        name: 'Control de rutas',
        to: '/rutas',
        roles: [Roles.ADMIN.role]
      },
      {
        component: CNavItem,
        name: 'Control de contenedores',
        to: '/contenedores',
        roles: [Roles.ADMIN.role]
      },
      {
        component: CNavItem,
        name: 'Control de colas',
        to: '/colas',
        roles: [Roles.ADMIN.role]
      },
      {
        component: CNavItem,
        name: 'Incidencias',
        to: '/incidencias',
        roles: [Roles.ADMIN.role]
      },
      {
        component: CNavItem,
        name: 'Configuración Panel',
        to: '/configuracion',
        roles: [Roles.ADMIN.role]
      },
      {
        component: CNavItem,
        name: 'Rangos de precios',
        to: '/rangos',
        roles: [Roles.ADMIN.role]
      },
      {
        component: CNavItem,
        name: 'Reponedores',
        to: '/reponedores',
        roles: [Roles.ADMIN.role]
      }
    ],
  },
  {
    component: CNavGroup,
    name: 'Peticiones',
    icon: <CIcon icon={cilList} customClassName="nav-icon" />,
    roles: [Roles.ADMIN.role, Roles.REPONEDOR.role, Roles.ALMACEN.role, Roles.SAT.role],
    items: [
      {
        component: CNavItem,
        name: 'Mis peticiones',
        to: '/mis-peticiones',
        roles: [Roles.ADMIN.role, Roles.REPONEDOR.role, Roles.ALMACEN.role, Roles.SAT.role]
      },
      {
        component: CNavItem,
        name: 'Panel de peticiones',
        to: '/panel-peticiones',
        roles: [Roles.ADMIN.role, Roles.REPONEDOR.role]
      }
    ],
  },
  {
    component: CNavItem,
    name: 'Agenda',
    to: '/agenda',
    icon: <CIcon icon={cilCreditCard} customClassName="nav-icon" />,
    roles: [Roles.ADMIN.role]
  },
  {
    component: CNavGroup,
    name: 'Usuarios',
    icon: <CIcon icon={cilGroup} customClassName="nav-icon" />,
    roles: [Roles.ADMIN.role],
    items: [
      // {
      //   component: CNavItem,
      //   name: 'Empleados',
      //   to: '/empleados',
      //   roles: [Roles.ADMIN.role]
      // },
      {
        component: CNavItem,
        name: 'Usuarios',
        to: '/usuarios',
        roles: [Roles.ADMIN.role]
      },
      {
        component: CNavItem,
        name: 'Estadísticas',
        to: '/estadisticas',
        roles: [Roles.ADMIN.role]
      }
    ],
  },
]

export default _nav
